import { Injectable, OnDestroy, signal } from "@angular/core";
import { io, Socket } from "socket.io-client";
import { Observable, Subject } from "rxjs";
import { CookieService } from "ngx-cookie";
import { SOCKET_SECRET_TOKEN, SOCKET_URL } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class SocketService implements OnDestroy {
  private socket: Socket | null = null;
  private subjects = new Map<string, Subject<any>>();

  constructor(private cookieService: CookieService) {}

  connect(): void {
    if (this.socket?.connected) return;

    const token = SOCKET_SECRET_TOKEN;

    this.socket = io(SOCKET_URL, {
      auth: { token, clientType: "user" },
      transports: ["websocket"],
    });

    this.socket.on("connect", () => {});

    this.socket.on("healthmap.completed", (data) => {});

    this.socket.on("connect_error", (err) => {
      console.warn("[SocketService] Connection error:", err.message);
    });
  }

  /**
   * Listen to a server-emitted event. Returns an Observable that emits each time the event fires.
   * Reuses the same Subject per event name so multiple subscribers share one listener.
   */
  listen<T = any>(event: string): Observable<T> {
    if (!this.subjects.has(event)) {
      const subject = new Subject<T>();
      this.subjects.set(event, subject);
      this.socket?.on(event, (data: T) => subject.next(data));
    }
    return this.subjects.get(event)!.asObservable();
  }

  emit(eventName: string, data?: any): void {
    this.socket?.emit(eventName, data);
  }

  disconnect(): void {
    this.socket?.disconnect();
    this.subjects.forEach((s) => s.complete());
    this.subjects.clear();
    this.socket = null;
  }

  ngOnDestroy(): void {
    this.disconnect();
  }
}
